import { scoreTriggerIntoEditable, scoreTriggerIntoSendable } from '@/services/api/resources/scoreTrigger';
import { IssueTemplateEditable } from '@/ui/DTO';
import { IssueTemplateRecord, IssueTemplateSendable } from '@/entities/issueTemplate';
import { v4 as uuidv4 } from 'uuid';

export const intoSendable = (resource: IssueTemplateEditable): IssueTemplateSendable => ({
  title: resource.title,
  description: resource.description,
  priority: resource.priority,
  assignees: resource.assignees,
  assignedGroups: resource.assignedGroups,
  associateAssignees: resource.associateAssignees,
  entityItemSpecificAssignments: resource.entityItemSpecificAssignments,
  dueIn: resource.dueIn ?? null,
  scoreTrigger: scoreTriggerIntoSendable(resource.scoreTrigger),
  approvalsEnabled: resource.approvalsEnabled,
  approvalsEntitySpecificAssignments: resource.approvalsEntitySpecificAssignments,
  approvers: resource.approvers,
});

export const intoEditable = (resource: IssueTemplateRecord): IssueTemplateEditable => ({
  id: resource.id,
  title: resource.data.title,
  description: resource.data.description,
  priority: resource.data.priority,
  assignees: resource.data.assignees.map(a => a.id),
  assignedGroups: resource.data.assignedGroups.map(a => a.id),
  associateAssignees: resource.data.associateAssignees.map(a => a.email),
  dueIn: resource.data.dueIn,
  scoreTrigger: scoreTriggerIntoEditable(resource.data.scoreTrigger),
  wasChanged: false,
  softDeleted: false,
  entityItemSpecificAssignments: resource.data.entityItemSpecificAssignments,
  internalId: uuidv4(),
  approvalsEnabled: resource.data.approvalsEnabled,
  approvalsEntitySpecificAssignments: resource.data.approvalsEntitySpecificAssignments,
  approvers: resource.data.approvers.map(a => a.id),
});
